export default class EditPhraseBookPhraseController {

}
